(function () {
  var drawer = document.getElementById('opt-mobile-drawer');
  if (!drawer) return;

  var body = document.body;
  var toggle = document.querySelector('.js-mobile-nav-toggle');
  var backdrop = document.querySelector('.opt-mobile-backdrop');
  var panels = Array.prototype.slice.call(drawer.querySelectorAll('[data-panel]'));
  var stack = ['root'];
  var scrollPositions = {};
  var touchStartX = 0;
  var touchStartY = 0;
  var isOpen = false;

  function currentId() {
    return stack[stack.length - 1];
  }

  function panelById(id) {
    return drawer.querySelector('[data-panel="' + id + '"]');
  }

  function setExpanded(open) {
    if (toggle) {
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      toggle.classList.toggle('mobile-nav--open', !open);
      toggle.classList.toggle('mobile-nav--close', open);
    }
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    if (backdrop) backdrop.setAttribute('aria-hidden', open ? 'false' : 'true');
  }

  function trap() {
    if (!window.slate || !window.jQuery) return;
    slate.a11y.trapFocus({
      $container: window.jQuery(drawer),
      namespace: 'optMobileDrawer'
    });
  }

  function untrap() {
    if (!window.slate || !window.jQuery) return;
    slate.a11y.removeTrapFocus({
      $container: window.jQuery(drawer),
      namespace: 'optMobileDrawer'
    });
  }

  function focusPanel(id) {
    var panel = panelById(id);
    if (!panel) return;
    var target = panel.querySelector('[data-panel-back]') || panel.querySelector('input, button, a');
    if (target) target.focus();
    else panel.focus();
  }

  function renderPanels() {
    var active = currentId();
    panels.forEach(function (panel) {
      var id = panel.getAttribute('data-panel');
      var isCurrent = id === active;
      var inStack = stack.indexOf(id) !== -1;
      panel.classList.toggle('is-active', isCurrent);
      panel.classList.toggle('is-stacked', inStack && !isCurrent);
      panel.setAttribute('aria-hidden', isCurrent ? 'false' : 'true');
      if (isCurrent) panel.removeAttribute('inert');
      else panel.setAttribute('inert', '');
    });
  }

  function openPanel(id) {
    if (!panelById(id) || id === currentId()) return;
    var from = panelById(currentId());
    if (from) scrollPositions[currentId()] = from.scrollTop;
    stack.push(id);
    renderPanels();
    var next = panelById(id);
    if (next) next.scrollTop = 0;
    window.setTimeout(function () { focusPanel(id); }, 300);
  }

  function backPanel() {
    if (stack.length < 2) return;
    stack.pop();
    renderPanels();
    var parent = panelById(currentId());
    if (parent && typeof scrollPositions[currentId()] === 'number') {
      parent.scrollTop = scrollPositions[currentId()];
    }
    window.setTimeout(function () { focusPanel(currentId()); }, 300);
  }

  function resetStack() {
    stack = ['root'];
    renderPanels();
    var root = panelById('root');
    if (root) root.scrollTop = 0;
  }

  function openDrawer() {
    if (isOpen) return;
    isOpen = true;
    resetStack();
    drawer.classList.add('active');
    body.classList.add('menuOn');
    setExpanded(true);
    trap();
    window.setTimeout(function () { focusPanel('root'); }, 50);
  }

  function closeDrawer(options) {
    options = options || {};
    if (!isOpen && !drawer.classList.contains('active')) {
      resetStack();
      return;
    }
    isOpen = false;
    drawer.classList.remove('active');
    body.classList.remove('menuOn');
    setExpanded(false);
    untrap();
    resetStack();
    if (!options.skipFocus && toggle) toggle.focus();
  }

  function toggleDrawer() {
    if (drawer.classList.contains('active')) closeDrawer();
    else openDrawer();
  }

  if (toggle) {
    toggle.setAttribute('aria-controls', 'opt-mobile-drawer');
    toggle.setAttribute('aria-expanded', 'false');
    toggle.addEventListener('click', function (evt) {
      evt.preventDefault();
      toggleDrawer();
    });
  }

  drawer.addEventListener('click', function (evt) {
    var closer = evt.target.closest('.closemobileMenu');
    if (closer) {
      evt.preventDefault();
      closeDrawer();
      return;
    }
    var back = evt.target.closest('[data-panel-back]');
    if (back) {
      evt.preventDefault();
      backPanel();
      return;
    }
    var opener = evt.target.closest('[data-open-panel]');
    if (opener) {
      evt.preventDefault();
      openPanel(opener.getAttribute('data-open-panel'));
    }
  });

  if (backdrop) {
    backdrop.addEventListener('click', function (evt) {
      evt.preventDefault();
      closeDrawer();
    });
  }

  document.addEventListener('keydown', function (evt) {
    if (evt.key === 'Escape' && body.classList.contains('menuOn')) {
      evt.preventDefault();
      closeDrawer();
    }
  });

  drawer.addEventListener('touchstart', function (evt) {
    if (!evt.touches || !evt.touches[0]) return;
    touchStartX = evt.touches[0].clientX;
    touchStartY = evt.touches[0].clientY;
  }, { passive: true });

  drawer.addEventListener('touchend', function (evt) {
    if (!evt.changedTouches || !evt.changedTouches[0]) return;
    var dx = evt.changedTouches[0].clientX - touchStartX;
    var dy = Math.abs(evt.changedTouches[0].clientY - touchStartY);
    if (dx > 70 && dy < 50) closeDrawer();
  }, { passive: true });

  drawer.querySelectorAll('.opt-mobile-drawer__currency-list li').forEach(function (item) {
    item.addEventListener('click', function () {
      var code = item.getAttribute('data-currency');
      var source = document.querySelector('#currencies li[data-currency="' + code + '"]');
      if (source) source.click();
      else if (window.Currency && window.shopCurrency) {
        Currency.convertAll(Currency.currentCurrency || shopCurrency, code);
      }
    });
  });

  renderPanels();
  window.optMobileDrawer = {
    open: openDrawer,
    close: function () { closeDrawer({ skipFocus: true }); }
  };
})();
